import { Price } from '@vfde-brix/core';
import {
    createFeatureTileComponent,
    FeatureTile,
} from '@vfde-brix/feature-tile';
import { StateProps } from '../container/DeviceDetail/interface';

/**
 * Mount the Feature Tile
 * @param container
 * @param onChange
 */
const mountFeatureTile = (containerId: string, onChange: (event: Event, checked: boolean) => void): FeatureTile => {
    const containerEle = document.getElementById(containerId) as HTMLElement;

    return containerEle && createFeatureTileComponent(containerEle, {
        onChange,
    });
};

/**
 * Update Insurance Feature Tile
 * @param featureTile
 * @param insurance
 * @param isHardwareOnly
 */
export const updateInsuranceFeatureTile = (featureTile: FeatureTile, {offer, hasInsurance, isHardwareOnly}: Partial<StateProps>) => {
    // We have to get the feature tile properties here and update it because the promoPrice is nested
    const properties = featureTile.getProperties();
    properties.promoPrice.price = Price.fromNumber(offer.insurance.price.gross);
    properties.optChecked = hasInsurance && !isHardwareOnly;
    properties.optDisabled = isHardwareOnly;
    featureTile.update(properties);
};

export default mountFeatureTile;
